import { Message } from '../../MessageBus/Message';


export class UpdateCommand extends Message
{
    constructor(
        Id: string,
        Folder: string,
        Content: object)
    {
        super("Update", { Id, Folder, Content });
    }
}
